<template>
  <div>
    <TopNav>
      <template v-slot:barmenu>
        <v-btn @click="clearResults()" v-ripple="{ class: 'primary--text' }" class="rounded-0 active" text>
          <v-icon>mdi-magnify</v-icon>
          <div>
            Discover
            <div class="text-caption red--text text--lighten-4" style="font-size: 0.6rem; text-transform: lowercase;">under construction</div>
          </div>
        </v-btn>
        <v-btn @click="$router.replace('/decisions')" v-ripple="{ class: 'primary--text' }" class="rounded-0" text>
          <v-icon>mdi-view-dashboard-variant</v-icon>
          Decisions
        </v-btn>
      </template>
      <template v-slot:drawermenu>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <div>
                Discover
                <div class="text-caption red--text text--lighten-4" style="font-size: 0.6rem; text-transform: lowercase;">under construction</div>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </TopNav>
    <v-container v-if="searching" class="px-0">
      <v-row justify="center">
        <v-col cols="12" align="center">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else-if="!searching && showingResults" class="px-0">
      <form @submit.prevent="submitSearch">
      <v-row no-gutter class="d-flex justify-space-between align-center">

          <v-text-field
            v-model="query"
            class="search-input"
            outlined
            clearable
            dense
            hide-details
            prepend-inner-icon="mdi-magnify"
            :error-messages="queryErrors"
            @change="$v.query.$touch()"
            @keydown="$v.query.$touch()"
            @blur="$v.query.$touch()"
          >
          </v-text-field>

          <v-btn
            class="ml-2"
            color="primary"
            type="submit"
            :disabled="!query || $v.query.$invalid"
          >
            Search
          </v-btn>
      </v-row>
      </form>
      <v-row justify="center" dense>
        <v-col cols="2" align="center">
          <div class="subtitle-1 px-4 mt-4">
            TODO Criteria filters
          </div>
        </v-col>
        <v-col cols="8" align="center">
          <div class="d-flex flex-wrap">
            <v-card
              v-for="n in 15"
              :key="n"
              class="ma-4"
              :maxWidth="computedMaxCardWidth"
            >
              <v-img
                :eager="true"
                :src="optionImgSrc"
                class="white--text align-end"
                contain
                height="200px"
                min-width="248px"
              >
              </v-img>
              <v-divider></v-divider>
              <v-card-title class="subtitle-2 font-weight-bold flex-column">
                <span class="d-option-card-name">
                  Option {{ n }} name
                </span>
                <v-btn
                  text
                  dark
                  x-small
                  target="_blank"
                  href="http://www.decidedly.online"
                >
                  <span class="accent--text">hostname {{n}}</span><v-icon class="ml-1" color="accent" x-small>mdi-open-in-new</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </div>
        </v-col>
        <v-col cols="2" align="center" >
          <div class=" mt-4">
            <h4>Decisions</h4>
            <div class="mb-4">
              todo (matching decisions)
            </div>
            <h4>Discussions</h4>
            <div class="mb-4">
              todo (matching forum topics and dicsissions)
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else class="px-0">
      <v-row justify="center">
        <v-col cols="12" align="center">
          <span class="subtitle-1 px-4">
            Search to discover options to add to your decisions and learn how others made their decisions
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center">
        <v-col cols="12">
          <v-carousel
            continuous
            cycle
            :show-arrows="false"
            height="40"
            vertical
            hide-delimiters
          >
            <v-carousel-item
              v-for="(slide, i) in exampleSearches"
              :key="i"
            >
              <v-sheet
                color="white"
                height="100%"
                tile
              >
                <v-row
                  justify="center"
                >
                  <span class="text-h5 text-lg-h4 text--primary">
                    {{ slide }}
                  </span>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
      <v-row align="start" justify="center">
        <v-col cols="12" align="center">
          <form @submit.prevent="submitSearch">
            <v-text-field
              v-model="query"
              class="search-input"
              outlined
              clearable
              prepend-inner-icon="mdi-magnify"
              :error-messages="queryErrors"
              @change="$v.query.$touch()"
              @keydown="$v.query.$touch()"
              @blur="$v.query.$touch()"
            >
            </v-text-field>

            <v-btn
              class="mb-2"
              color="primary"
              type="submit"
              :disabled="!query || $v.query.$invalid"
            >
              Search
            </v-btn>
          </form>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" align="center">
          <span class="subtitle-1 px-4">
            Or browse our <a href="https://forums.decidedly.online" target="_blank">Decidedly friendly forums</a>.
          </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
// import axios from 'axios'

// import { mapState, mapGetters } from 'vuex'

// @ is an alias to /src
import TopNav from '@/components/TopNav.vue'

// vuelidate
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

// Mixins
//import boilerplatMixin from '@/mixins/BoilerplateLoader.js'

export default {
  name: 'Discover',
  //mixins: [boilerplatMixin],
  components: {
    TopNav
  },
  data () {
    return {
      // decisions: [],
      searching: false,
      showingResults: false,
      query: null,
      currentUser: firebase.auth().currentUser,
      maxCardWidth: 350,
      exampleSearches: [
        'New laptop',
        'New fridge less than 900mm wide',
        'Telescope to see the rings of Saturn',
        'Hybrid or fully electric car',
        'Water tank for my garden'
      ],
    }
  },
  mixins: [validationMixin],
  validations: {
    query: {required, maxLength: maxLength(200) }
  },
  computed: {
    queryErrors () {
      const errors = []
      if (!this.$v.query.$dirty) return errors
      !this.$v.query.maxLength && errors.push('Criteria name must be at most 200 characters long')
      return errors
    },
    optionImgSrc () {
      let res = `${Constants.SCREENSHOT_CDN}/unknownimage.png`
      return res
    },
    computedMaxCardWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%'
        case 'sm': return '100%'
        default: return this.maxCardWidth
      }
    },
  },
  mounted: function () {
    this.currentUser = firebase.auth().currentUser
    // this.fetchUserDecisions()
    if (this.$route.query && this.$route.query.q) {
      this.query = this.$route.query.q
      this.startSearch()
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      if (to.query && to.query.q) {
        let isNewQuery = false
        if (from.query && from.query.q) {
          isNewQuery = from.query.q !== to.query.q
        } else {
          isNewQuery = true
        }

        if (isNewQuery) {
          this.query = to.query.q
          this.startSearch()
        }
      }
    }
  },
  methods: {
    submitSearch: function () {
      this.$router.replace({ name: 'Discover', query: { q: this.query } }).catch(()=>{}) // Silently catch errors about avoiding reduntand navigation to the same route
    },
    startSearch: function () {
      this.searching = true
      setTimeout(() => {
        this.showingResults = true
        this.searching = false
      }, 3000)
    },
    clearResults: function () {
      this.showingResults = false
      this.searching = false
      if (this.query) {
        this.query = null
        this.$router.replace({ name: 'Discover', query: {} }).catch(()=>{}) // Silently catch errors about avoiding reduntand navigation to the same route
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search-input.v-text-field {
  width: 50%;
  min-width: 300px;
}

.v-card__title {
  font-size: 1rem;
  position: relative;
  // background-color: rgba(0,0,0,0.6);
  padding: 5px 16px;
}

.d-option-card-name {
  .edit-card-name {
    display: none;
  }

  &:hover {
    .edit-card-name {
      display: block;
    }
  }
}
</style>
